import React from 'react';
import PropTypes from 'prop-types';

import Popper from './../../Popper';
import MenuList from '@material-ui/core/MenuList';
import MoreVertical from '@ellucian/ds-icons/lib/MoreVertical';

import createActionMenuItems from './createActionMenuItems';
import decorateActionMenuChildren from './decorateActionMenuChildren';
import { default as withStyles } from './../../styles';
import { borderRadiusXSmall, borderWidthThin } from './../../styles/tokens';

export var styles = function styles(theme) {
    return {
        paper: {
            padding: 0,
            border: borderWidthThin + ' solid ' + theme.palette.grey[400]
        },
        menuList: {
            maxWidth: '18.750rem',
            borderRadius: '' + borderRadiusXSmall
        }
    };
};

/**
 * PopperWrapper
 */
var PopperWrapper = function PopperWrapper(props) {
    var classes = props.classes,
        actions = props.actions,
        placement = props.placement,
        menuId = props.menuId,
        id = props.id,
        edsContext = props.edsContext,
        PopperProps = props.PopperProps,
        PaperProps = props.PaperProps,
        open = props.open,
        handleClose = props.handleClose,
        buttonRef = props.buttonRef,
        children = props.children;


    var popperPlacement = placement ? placement : edsContext.dir === 'rtl' ? 'bottom-start' : 'bottom-end';
    var PopperPropsProps = Object.assign({}, PopperProps);
    var offset = 20; // Bring popper closer to icon

    // TODO: Do this with lodash or ES6 way.
    if (PopperPropsProps.modifiers) {
        PopperPropsProps.modifiers.offset = offset;
    } else {
        PopperPropsProps.modifiers = { offset: offset };
    }

    var onKeyDown = function onKeyDown(event) {
        var key = event.key;

        if (key === 'Escape' || key === 'Tab') {
            event.preventDefault();
            handleClose();
        }
    };

    return React.createElement(
        Popper,
        Object.assign({
            arrow: true,
            anchorEl: buttonRef.current,
            open: open,
            placement: popperPlacement,
            onClickAway: handleClose,
            className: 'eds-actionmenu-popper',
            PaperProps: Object.assign({
                'aria-live': 'off',
                classes: { root: classes.paper },
                elevation: 1
            }, PaperProps)

        }, PopperPropsProps, {
            onKeyDown: onKeyDown,
            transition: false
        }),
        React.createElement(
            'div',
            null,
            React.createElement(
                MenuList,
                { id: menuId || id, className: classes.menuList, autoFocusItem: open },
                decorateActionMenuChildren(children, handleClose) || createActionMenuItems(actions, handleClose)
            )
        )
    );
};

// TODO: Make `children` prop required after `actions` prop is removed
PopperWrapper.propTypes = {
    children: PropTypes.node,
    buttonRef: PropTypes.object,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    classes: PropTypes.object,
    actions: PropTypes.arrayOf(PropTypes.object),
    className: PropTypes.string,
    edsContext: PropTypes.object,
    menuId: PropTypes.string,
    id: PropTypes.string,
    placement: PropTypes.oneOf(['bottom-end', 'bottom-start']),
    PaperProps: PropTypes.object,
    PopperProps: PropTypes.object
};

PopperWrapper.defaultProps = {
    initialOpenOverride: false,
    icon: React.createElement(MoreVertical, null)
};

export default withStyles(styles)(PopperWrapper);